export enum DiscountTypeEnum {
    Percentage = 0,
    SubtractFromPrice = 1,
    SetAsFinalPrice = 2,
    Free = 3
}
